<template>
  <div class="quiz_text">
    <span v-html="text"></span>
  </div>
</template>

<script>
export default {
  name: 'QuizText',
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
  .quiz_text {
    color: #ec8dae;
    font-size: 18px;
    line-height: 28px;
    width: 372px;
    height: 286px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_text {
      width: 100%;
      height: 100%;
    }
  }

</style>
